/**
 * gibt ein Objekt zurück, mit dem per Convenience-Methoden auf ein Canvas Pixelweise gezeichnet werden kann
 */
import * as Debugs from "oc-threejs/Debugs";

export type RGBA = [number, number, number, number];

export class PixelAccessor {
  canvas: HTMLCanvasElement;
  width: number;
  height: number;
  ctx: CanvasRenderingContext2D;
  imageData: ImageData;
  data: Uint8ClampedArray;
  private _gray: RGBA;

  constructor(canvas: HTMLCanvasElement) {
    this.canvas = canvas;
    this.width = canvas.width;
    this.height = canvas.height;
    this.ctx = canvas.getContext("2d")!;
    this.imageData = this.ctx.getImageData(0, 0, this.width, this.height);
    this.data = this.imageData.data;
    this._gray = this.createRGBA();
  }

  done(): void {
    this.ctx.putImageData(this.imageData, 0, 0);
  }

  index(x: number, y: number): number {
    return (((x + this.width) % this.width) + ((y + this.height) % this.height) * this.width) * 4;
  }

  createRGBA(): RGBA {
    return [0, 0, 0, 0];
  }

  getRGBA(x: number, y: number, color: RGBA): void {
    const i = this.index(x, y);
    const data = this.data;
    color[0] = data[i + 0];
    color[1] = data[i + 1];
    color[2] = data[i + 2];
    color[3] = data[i + 3];
  }

  setRGBA(x: number, y: number, color: RGBA): void {
    const i = this.index(x, y);
    const data = this.data;
    data[i + 0] = color[0];
    data[i + 1] = color[1];
    data[i + 2] = color[2];
    data[i + 3] = color[3];
  }

  getGray(x: number, y: number): number {
    const g = this._gray;
    this.getRGBA(x, y, g);
    return (g[0] + g[1] + g[2]) / 3;
  }

  setGray(x: number, y: number, gray: number): void {
    const g = this._gray;
    g[0] = gray;
    g[1] = gray;
    g[2] = gray;
    g[3] = 255;
    this.setRGBA(x, y, g);
  }

  forRaster(pixelIterator: (x: number, y: number) => void): void {
    const w = this.width;
    const h = this.height;
    for (let y = 0; y < h; y++) {
      for (let x = 0; x < w; x++) {
        pixelIterator(x, y);
      }
    }
  }

  show(): void {
    this.done();
    Debugs.showImageInWindow(this.canvas);
  }
}
